import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaGlobe,
  FaLightbulb,
  FaLock,
  FaSync,
  FaRocket,
  FaChartLine,
} from "react-icons/fa";

function FeaturesSectionComponent() {
  return (
    <section
      id="features"
      className="section-spacing landing-dark-background"
    >
      <Container>
        <div className="text-center mb-5">
          <h2 className="fw-bold mb-3 landing-page-text">
            Powerful Features For Every Need
          </h2>
          <p className="lead text-muted mx-auto" style={{ maxWidth: "700px" }}>
            Explore the comprehensive suite of features designed to enhance your
            AI experience and maximize productivity.
          </p>
        </div>
        <Row className="g-4">
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaGlobe size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">
                  Multi-Model Access
                </h3>
                <p className="text-muted">
                  Switch between different AI models with a single click. Find
                  the perfect model for each specific task.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaLightbulb size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">
                  Smart Context Memory
                </h3>
                <p className="text-muted">
                  Our platform remembers your conversation history and maintains
                  context for more relevant, consistent responses.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaLock size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">Privacy Focused</h3>
                <p className="text-muted">
                  Your data is yours. We prioritize privacy with opt-in data
                  collection and secure storage of conversations.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaSync size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">Model Comparison</h3>
                <p className="text-muted">
                  Compare responses from different models side-by-side to
                  understand their unique strengths and approaches.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaRocket size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">
                  Customizable Experience
                </h3>
                <p className="text-muted">
                  Tailor your AI interactions with customizable parameters,
                  instruction sets, and personalized preferences.
                </p>
              </div>
            </div>
          </Col>
          <Col md={6} lg={4}>
            <div className="animate-on-scroll">
              <div className="p-4 h-100">
                <div className="feature-icon d-flex align-items-center justify-content-center mb-4">
                  <FaChartLine size={32} />
                </div>
                <h3 className="h4 mb-3 landing-page-text">Usage Analytics</h3>
                <p className="text-muted">
                  Track your AI usage with detailed analytics on tokens,
                  queries, and model performance over time.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default FeaturesSectionComponent;
